import { useState, useEffect, memo } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, Grid, Button } from '@mui/material';
import { FULL_CENSUS_COLUMNS } from '../../../../reusable-components/datagrid/censusColumns';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import CensusModal from './CensusModal';
import { HOST_API_URL } from '../../../../config-global';
import Iconify from '../../../../reusable-components/iconify';
import axiosInstance from '../../../../utils/axios';
import EditIconButton from '../../../../reusable-components/basic-buttons/EditIconButton';
import { useScopeCheck } from '../../../../reusable-components/scopes';

export default function CensusView() {
    const [data, setData] = useState([]);
    const [openFacilityId, setOpenFacilityId] = useState(0);
    const [loading, setLoading] = useState(false);
    const hasEditAccess = useScopeCheck(['Edit-Census'], true)

    useEffect(() => {
        setLoading(true);
        axiosInstance.get('/Admin/FacilityCensus/FacilitiesCensus')
            .then((res) => setData(res.data ?? []))
            .catch(() => enqueueSnackbar("Failed to load census data", { variant: "error" }))
            .finally(() => setLoading(false))
    }, []);

    const tableToolbar = memo(() => (
        <Box sx={{ display: 'inline-block', ml: 1 }}>
            <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => window.open(`${HOST_API_URL}Api/Admin/FacilityCensus/DownloadFacilityCensus`, '_blank')}
                startIcon={<Iconify icon="file-icons:microsoft-excel" />}
            >
                Download
            </Button>
        </Box>
    ));

    const columns = hasEditAccess
        ? [
            ...FULL_CENSUS_COLUMNS,
            {
                field: "actions",
                sortable: false,
                width: 70,
                headerName: "Actions",
                renderCell: (params) => <EditIconButton onClick={() => setOpenFacilityId(params.row.facilityId ?? 0)} />
            }
        ]
        : [...FULL_CENSUS_COLUMNS];

    return (
        <Grid item xs={12}>
            <CustomDataGrid
                gridId="admin-census-view"
                boxSX={{ width: '100%', height: 'calc(100vh - 220px)' }}
                data={data}
                gridColumns={columns}
                isLoading={loading}
                CustomLeftToolbar={tableToolbar}
            />
            <CensusModal onClose={() => setOpenFacilityId(0)} facilityId={openFacilityId} isDialog onSave={(newData) =>
                setData(data => [...data.map(val => val.facilityId === newData.facilityId ? { ...newData, id: val.id } : val)])} />
        </Grid>
    );
}
